// Inline SVG diagram builders - returned as data URIs.
// These are used inside course content where a clear diagram helps learning.

const svg = (inner, w = 800, h = 420) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="${w}" height="${h}">${inner}</svg>`
  )}`;

const baseStyle = `
  <style>
    .bg { fill: #FDFBF7; }
    .box { fill: #FFFFFF; stroke: #0F4C81; stroke-width: 2; }
    .box-accent { fill: #FFF4E6; stroke: #D97706; stroke-width: 2; }
    .box-muted { fill: #F5F2EB; stroke: #A38F6A; stroke-width: 1.5; }
    .t { font-family: 'Outfit', sans-serif; font-size: 14px; fill: #1A1A1A; }
    .t-b { font-family: 'Outfit', sans-serif; font-size: 16px; font-weight: 700; fill: #0F4C81; }
    .t-s { font-family: 'Outfit', sans-serif; font-size: 12px; fill: #4A4A4A; }
    .arrow { stroke: #0F4C81; stroke-width: 2; fill: none; marker-end: url(#arr); }
    .arrow-a { stroke: #D97706; stroke-width: 2; fill: none; marker-end: url(#arra); }
  </style>
  <defs>
    <marker id="arr" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto">
      <path d="M0,0 L10,5 L0,10 Z" fill="#0F4C81"/>
    </marker>
    <marker id="arra" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto">
      <path d="M0,0 L10,5 L0,10 Z" fill="#D97706"/>
    </marker>
  </defs>
`;

// ———— ERP central hub diagram ————
export const erpDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <circle cx="400" cy="210" r="80" class="box-accent"/>
  <text x="400" y="205" text-anchor="middle" class="t-b">ERP</text>
  <text x="400" y="225" text-anchor="middle" class="t-s">Central Database</text>

  <g>
    <rect x="60" y="40" width="170" height="70" rx="8" class="box"/>
    <text x="145" y="72" text-anchor="middle" class="t-b">Finance</text>
    <text x="145" y="92" text-anchor="middle" class="t-s">GL • AP • AR • Controlling</text>
  </g>
  <g>
    <rect x="570" y="40" width="170" height="70" rx="8" class="box"/>
    <text x="655" y="72" text-anchor="middle" class="t-b">Sales</text>
    <text x="655" y="92" text-anchor="middle" class="t-s">Orders • Billing • CRM link</text>
  </g>
  <g>
    <rect x="60" y="310" width="170" height="70" rx="8" class="box"/>
    <text x="145" y="342" text-anchor="middle" class="t-b">Procurement</text>
    <text x="145" y="362" text-anchor="middle" class="t-s">PR • PO • Vendors</text>
  </g>
  <g>
    <rect x="570" y="310" width="170" height="70" rx="8" class="box"/>
    <text x="655" y="342" text-anchor="middle" class="t-b">HR</text>
    <text x="655" y="362" text-anchor="middle" class="t-s">Payroll • Talent</text>
  </g>
  <g>
    <rect x="315" y="20" width="170" height="60" rx="8" class="box"/>
    <text x="400" y="55" text-anchor="middle" class="t-b">Manufacturing</text>
  </g>
  <g>
    <rect x="315" y="340" width="170" height="60" rx="8" class="box"/>
    <text x="400" y="375" text-anchor="middle" class="t-b">Warehouse</text>
  </g>

  <path class="arrow" d="M230 75 Q300 140 330 175"/>
  <path class="arrow" d="M570 75 Q500 140 470 175"/>
  <path class="arrow" d="M230 345 Q300 280 330 245"/>
  <path class="arrow" d="M570 345 Q500 280 470 245"/>
  <path class="arrow" d="M400 80 L400 130"/>
  <path class="arrow" d="M400 290 L400 340"/>`
);

// ———— 3-tier architecture ————
export const threeTierDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">SAP Three-Tier Architecture</text>

  <g>
    <rect x="120" y="60" width="560" height="90" rx="8" class="box-accent"/>
    <text x="400" y="95" text-anchor="middle" class="t-b">Presentation Layer</text>
    <text x="400" y="120" text-anchor="middle" class="t-s">SAP GUI • SAP Fiori (browser) • Mobile • Excel Add-ins</text>
    <text x="400" y="140" text-anchor="middle" class="t-s">— What the user sees —</text>
  </g>
  <g>
    <rect x="120" y="170" width="560" height="90" rx="8" class="box"/>
    <text x="400" y="205" text-anchor="middle" class="t-b">Application Layer</text>
    <text x="400" y="230" text-anchor="middle" class="t-s">ABAP / Java work processes • Business logic • Dispatcher</text>
    <text x="400" y="250" text-anchor="middle" class="t-s">— Where rules execute —</text>
  </g>
  <g>
    <rect x="120" y="280" width="560" height="90" rx="8" class="box-muted"/>
    <text x="400" y="315" text-anchor="middle" class="t-b">Database Layer</text>
    <text x="400" y="340" text-anchor="middle" class="t-s">SAP HANA • Oracle • MS SQL • DB2 • ASE</text>
    <text x="400" y="360" text-anchor="middle" class="t-s">— Where data lives —</text>
  </g>

  <path class="arrow" d="M400 150 L400 170"/>
  <path class="arrow" d="M400 260 L400 280"/>`
);

// ———— P2P flow ————
export const p2pDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">Procure-to-Pay (P2P) End-to-End</text>
  ${[
    ["Purchase Requisition", "PR created by dept"],
    ["RFQ / Source", "Vendor quotations"],
    ["Purchase Order", "PO sent to vendor"],
    ["Goods Receipt", "MIGO posting"],
    ["Invoice Verify", "3-way match"],
    ["Vendor Payment", "F110 payment run"],
  ]
    .map(([t, s], i) => {
      const x = 40 + (i % 3) * 250;
      const y = 80 + Math.floor(i / 3) * 130;
      return `<g>
        <rect x="${x}" y="${y}" width="220" height="90" rx="8" class="${i % 2 ? 'box' : 'box-accent'}"/>
        <text x="${x + 110}" y="${y + 38}" text-anchor="middle" class="t-b">${i + 1}. ${t}</text>
        <text x="${x + 110}" y="${y + 62}" text-anchor="middle" class="t-s">${s}</text>
      </g>`;
    })
    .join('')}
  <path class="arrow" d="M260 120 L290 120"/>
  <path class="arrow" d="M510 120 L540 120"/>
  <path class="arrow" d="M150 170 Q40 200 40 250"/>
  <path class="arrow" d="M260 260 L290 260"/>
  <path class="arrow" d="M510 260 L540 260"/>`
);

// ———— O2C flow ————
export const o2cDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">Order-to-Cash (O2C) End-to-End</text>
  ${[
    ["Inquiry / Quote", "Customer enquiry"],
    ["Sales Order", "VA01 create order"],
    ["Delivery", "VL01N outbound"],
    ["Goods Issue", "Stock reduced"],
    ["Billing", "VF01 invoice"],
    ["Customer Payment", "Incoming A/R"],
  ]
    .map(([t, s], i) => {
      const x = 40 + (i % 3) * 250;
      const y = 80 + Math.floor(i / 3) * 130;
      return `<g>
        <rect x="${x}" y="${y}" width="220" height="90" rx="8" class="${i % 2 ? 'box' : 'box-accent'}"/>
        <text x="${x + 110}" y="${y + 38}" text-anchor="middle" class="t-b">${i + 1}. ${t}</text>
        <text x="${x + 110}" y="${y + 62}" text-anchor="middle" class="t-s">${s}</text>
      </g>`;
    })
    .join('')}
  <path class="arrow" d="M260 120 L290 120"/>
  <path class="arrow" d="M510 120 L540 120"/>
  <path class="arrow" d="M150 170 Q40 200 40 250"/>
  <path class="arrow" d="M260 260 L290 260"/>
  <path class="arrow" d="M510 260 L540 260"/>`
);

// ———— SAP Activate phases ————
export const activateDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">SAP Activate Methodology</text>
  ${['Discover', 'Prepare', 'Explore', 'Realize', 'Deploy', 'Run']
    .map((p, i) => {
      const x = 40 + i * 125;
      return `<g>
        <polygon points="${x},80 ${x + 105},80 ${x + 125},130 ${x + 105},180 ${x},180 ${x + 20},130"
                 class="${i % 2 ? 'box-accent' : 'box'}"/>
        <text x="${x + 62}" y="${135}" text-anchor="middle" class="t-b">${p}</text>
      </g>`;
    })
    .join('')}
  <text x="400" y="230" text-anchor="middle" class="t-s">Each phase delivers defined outcomes and go/no-go checkpoints.</text>
  <rect x="60" y="260" width="680" height="120" rx="8" class="box-muted"/>
  <text x="80" y="285" class="t-b">Key Roles</text>
  <text x="80" y="310" class="t">• Project Manager — plans, budgets, governance</text>
  <text x="80" y="330" class="t">• Functional Consultant — process design &amp; configuration</text>
  <text x="80" y="350" class="t">• Technical / ABAP Consultant — custom development &amp; interfaces</text>
  <text x="80" y="370" class="t">• Basis Administrator — landscape, transports, performance</text>`
);

// ———— Master vs Transaction ————
export const dataTypesDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">Master Data vs Transaction Data</text>

  <rect x="60" y="70" width="320" height="300" rx="8" class="box"/>
  <text x="220" y="100" text-anchor="middle" class="t-b">Master Data</text>
  <text x="220" y="125" text-anchor="middle" class="t-s">Long-lived, rarely changes</text>
  <text x="80" y="165" class="t">• Customer master</text>
  <text x="80" y="195" class="t">• Vendor / Supplier master</text>
  <text x="80" y="225" class="t">• Material master</text>
  <text x="80" y="255" class="t">• Employee master</text>
  <text x="80" y="285" class="t">• GL account master</text>
  <text x="80" y="325" class="t-s">Entered once, reused across thousands of transactions.</text>

  <rect x="420" y="70" width="320" height="300" rx="8" class="box-accent"/>
  <text x="580" y="100" text-anchor="middle" class="t-b">Transaction Data</text>
  <text x="580" y="125" text-anchor="middle" class="t-s">Short-lived business events</text>
  <text x="440" y="165" class="t">• Sales order</text>
  <text x="440" y="195" class="t">• Purchase order</text>
  <text x="440" y="225" class="t">• Goods receipt</text>
  <text x="440" y="255" class="t">• Invoice document</text>
  <text x="440" y="285" class="t">• Payment posting</text>
  <text x="440" y="325" class="t-s">References master data — e.g., a PO points to a vendor.</text>`
);

// ———— Landscape DEV/QA/PROD ————
export const landscapeDiagram = svg(
  `${baseStyle}
  <rect class="bg" width="100%" height="100%"/>
  <text x="400" y="30" text-anchor="middle" class="t-b">Three-System Landscape &amp; Transport Flow</text>
  ${[
    ['DEV', 'Development', '#D97706'],
    ['QA', 'Quality / Test', '#0F4C81'],
    ['PROD', 'Production', '#1E7A3D'],
  ]
    .map(([code, label, color], i) => {
      const x = 80 + i * 240;
      return `<g>
        <rect x="${x}" y="110" width="180" height="160" rx="10" fill="#fff" stroke="${color}" stroke-width="3"/>
        <text x="${x + 90}" y="160" text-anchor="middle" font-family="Outfit" font-size="34" font-weight="700" fill="${color}">${code}</text>
        <text x="${x + 90}" y="200" text-anchor="middle" class="t-b">${label}</text>
        <text x="${x + 90}" y="225" text-anchor="middle" class="t-s">Client ${i === 0 ? '100' : i === 1 ? '200' : '300'}</text>
      </g>`;
    })
    .join('')}
  <path class="arrow-a" d="M260 190 L320 190"/>
  <path class="arrow-a" d="M500 190 L560 190"/>
  <text x="290" y="178" class="t-s" text-anchor="middle">Transport</text>
  <text x="530" y="178" class="t-s" text-anchor="middle">Transport</text>

  <text x="400" y="320" text-anchor="middle" class="t-s">Config &amp; code flow forward only. No changes are done directly in PROD.</text>`
);
